import './Footer.css'
import { Layout } from 'antd';
import SocialsLinks from '../Header/SocialsLinks'

function Footer() {

    const { Footer } = Layout;
    const currentYear = new Date().getFullYear()

    return (
        <div>
            <Footer className='footer'>
                <div className='d-flex row justify-content-center'>
                    <div className='socials-hidden-desktop'>
                        <SocialsLinks />
                    </div>
                </div>
                <div className='d-flex row justify-content-center mt-3'>
                    <span className="text-light">Copyright ©  {currentYear} </span>
                </div>
            </Footer>
        </div>
    )
}

export default Footer
